import React from 'react';
import { useSelector } from 'react-redux';
import { ArrowForward } from '@yme/assets/icons';
import { GHOST_VARIANT, TRAILING_ICON } from '@yme/atoms/button';
import { Carousel, useCarousel } from '@yme/atoms/carousel';
import { Col, Container, FlexibleCol, Row } from '@yme/atoms/grid';
import { MiniButton } from '@yme/atoms/mini-button';
import { useWindowSize } from '@yme/common/hooks';
import { GAP_BETWEEN_ITEMS } from '@yme/components/Destinations/UnitRelatedExperience/constants';
import { IndentWrapper } from '@yme/components/Separator';
import { DestinationCard } from '@yme/molecules/cards';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { buildKey } from '@yme/utils/common';
import { getSearchParams } from './helpers';
import { ButtonLinkStyled, LinkStyled } from './styled';
export function RelatedExperiences({ experiencesData, viewAllPath, itemName, searchParamName, title, isRemoveBottomIndent, }) {
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView } = useWindowSize();
    const { t } = useTranslation();
    const { activeItem, onClickPrevItem, onClickNextItem, indexOfCount, counts, setCounts } = useCarousel();
    const commonCarouselProps = {
        isRightToLeft,
        activeItem,
        onClickPrevItem,
        onClickNextItem,
        indexOfCount,
        counts,
    };
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent, isRightToLeft: isRightToLeft },
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(FlexWrapper, { justifyContent: "space-between" },
                        React.createElement(HeadingLevel2, null, title),
                        !isMobileView && (React.createElement(LinkStyled, { tabIndex: -1, to: {
                                pathname: viewAllPath,
                                search: getSearchParams(searchParamName, itemName),
                            } },
                            React.createElement(MiniButton, { isRightToLeft: isRightToLeft, iconType: ArrowForward, title: t('common_viewAll_link') }, t('common_viewAll_link'))))))),
            React.createElement(Row, { mt: "24px", lgMt: "32px" }, isMobileView ? (React.createElement(Col, null,
                React.createElement(Carousel, { ...commonCarouselProps, getterSize: GAP_BETWEEN_ITEMS, items: experiencesData, isDotsPanelVisible: true, ChildComponent: DestinationCard, setCounts: setCounts }),
                React.createElement(ButtonLinkStyled, { buttonLabel: t('common_viewAll_link'), buttonLink: viewAllPath, buttonLinkSearch: getSearchParams(searchParamName, itemName), buttonVariant: GHOST_VARIANT, iconComponent: ArrowForward, hasIconButton: TRAILING_ICON, isRightToLeft: isRightToLeft }))) : (React.createElement(React.Fragment, null, experiencesData.map((destinationData, index) => (React.createElement(FlexibleCol, { key: buildKey('destination-card', index), md: 4, lg: 4 },
                React.createElement(DestinationCard, { cardProps: destinationData, isRightToLeft: isRightToLeft }))))))))));
}
